import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { analytics, mountAnalytics } from "../../lib/analytics";

/**
 * One `page_view` per route change, and the vendor script mounted once.
 *
 * A single-page app fires exactly one real page load, so without this a tag
 * manager sees the customer arrive and never move again — every product page,
 * every category, the whole basket flow, invisible.
 *
 * Rendered inside `BrowserRouter` because `useLocation` needs the router, and
 * kept as its own component so `App` does not have to become a function body.
 */
export default function AnalyticsRouteTracker() {
  const location = useLocation();

  useEffect(() => { mountAnalytics(); }, []);

  useEffect(() => {
    // After the title effect of whichever page just mounted, so the event
    // carries the real document title rather than the previous page's.
    const id = window.setTimeout(() => {
      analytics.pageView(location.pathname + location.search, document.title);
    }, 0);
    return () => window.clearTimeout(id);
  }, [location.pathname, location.search]);

  return null;
}
